export const contentPopOver = (command) => {
  if (command === "introduc") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>
              กรณีที่ไม่สามารถเลือก "เลือกพิพากษา"
              ได้ให้ติดต่อกลับไปที่คนดูแลระบบ
            </li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "interestRate1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          {/* <p>
              <strong>วิธีการกรอก:</strong>
            </p> */}
          <ul>
            <li>ดอกเบี้ยของค่าชดใช้แทน</li>
            <li>
              ถ้าเลือกข้อมูลที่ช่องนี้จะไม่สามารถใช้กรอกต้นเงินและดอกเบี้ยที่คิดตามต้นเงินได้
            </li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "judgementLack1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ถ้าเลือกดอกเบี้ยค่าชดใช้แทนจะไม่สามารถกรอกข้อมูลได้</li>
            <li>กรอกจำนวนต้นเงินเป็นตัวเลข</li>
            <li>ข้อมูลมาจากศาลกำหนด</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "interestRateJudgeLack1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ดอกเบี้ยคิดตามต้นเงิน</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "dateInterest1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>วันที่เริ่มคิดดอกเบี้ยค่าชดใช้แทนหรือต้นเงิน</li>
            <li>
              กรุณีไม่รู้ว่าจะใส่วันอะไรให้ใส่วันประทับฟ้อง,วันพิพากษา
              แล้วแต่พิจารณา
            </li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "costUnless1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ค่าขาดประโยชน์ที่ศาลพิพากษาให้</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "interestRateCostUnless1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ดอกเบี้ยของค่าขาดประโยชน์</li>
            <li>
              กรุณีไม่รู้ว่าจะใส่วันอะไรให้ใส่วันประทับฟ้อง,วันพิพากษา
              แล้วแต่พิจารณา
            </li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "dateInterestCostUnless1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>วันที่เริ่มคิดดอกเบี้ยของค่าขาดประโยชน์</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "delayCostUnless1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>จำนวนวันที่จะคิดดอกเบี้ยถึง</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "delayCostUnless1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>จำนวนวันที่จะคิดดอกเบี้ยถึง</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "costPermonth1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ค่าขาดประโยชน์ที่ศาลตัดสินให้ชดใช้เป็นรายเดือน</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "costDay1") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>จำนวนเดือนที่ศาลตัดสินให้</li>
          </ul>
        </div>
      </>
    );
  }
};

export const contentPopOver2 = (command) => {
  if (command === "judgement2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          {/* <p>
              <strong>วิธีการกรอก:</strong>
            </p> */}
          <ul>
            <li>ค่าชดใช้แทนของจำเลยตามคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "interestRate2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          {/* <p>
              <strong>วิธีการกรอก:</strong>
            </p> */}
          <ul>
            <li>ดอกเบี้ยของค่าชดใช้แทนของจำเลยถัดไป</li>
            <li>
              ถ้าเลือกข้อมูลที่ช่องนี้จะไม่สามารถใช้กรอกต้นเงินและดอกเบี้ยที่คิดตามต้นเงินได้
            </li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "judgementLack2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>กรอกจำนวนต้นเงินเป็นตัวเลขของจำเลยพิพากษาถัดไป</li>
            <li>ถ้าเลือกดอกเบี้ยค่าชดใช้แทนจะไม่สามารถกรอกข้อมูลได้</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "interestRateLack2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ดอกเบี้ยคิดตามต้นเงิน</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "dateInterest2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>
              วันที่เริ่มคิดดอกเบี้ยค่าชดใช้แทนหรือต้นเงินของจำเลยในคำพิพากษาถัดไป
            </li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "delayCostUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>
              จำนวนวันที่จะคิดดอกเบี้ยตามคำพิพากษาถัดไปของค่าชำระแทน/ต้นเงิน
            </li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "costUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ค่าขาดประโยชน์ที่ศาลพิพากษาให้ของจำเลยในคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "interestRateCostUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ดอกเบี้ยของค่าขาดประโยชน์ของคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "dateInterestCostUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>วันที่เริ่มคิดดอกเบี้ยของค่าขาดประโยชน์ของคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "delayCostUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>จำนวนวันที่จะคิดดอกเบี้ยถึงของคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "delayCostUnless2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>จำนวนวันที่จะคิดดอกเบี้ยถึงของคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }

  if (command === "costPermonth2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>
              ค่าขาดประโยชน์ที่ศาลตัดสินให้ชดใชเป็นรายเดือนของคำพิพากษาถัดไป
            </li>
          </ul>
        </div>
      </>
    );
  }
  if (command === "CostUnlessDay2") {
    return (
      <>
        <div style={{ maxWidth: 300 }}>
          <ul>
            <li>ไม่เกินจำนวนเดือนที่ศาลตัดสินให้ของคำพิพากษาถัดไป</li>
          </ul>
        </div>
      </>
    );
  }
};
